import React, { useMemo } from 'react';
import { Form, useAsyncValue } from 'react-router-dom';
import { CMAccountResponse, CurrentUserDetails } from 'services/apiService';
import { Autocomplete, TextField, Button, Box, Stack } from '@mui/material';
// import { styled } from '@mui/material/styles';


const SwitchCmAccountForm = () => {
    const [cmAccounts, currentUserDetails] = useAsyncValue() as [
        CMAccountResponse,
        CurrentUserDetails
    ]
    const cmAccountList = useMemo(
        () => cmAccounts.results,
        [cmAccounts]
    )
    const default_cm_account = cmAccountList.find((cmAccount) => cmAccount.id === currentUserDetails.default_cm_account)
    const [cmAccount, setCmAccount] = React.useState(default_cm_account || null)
    return (
        <Box component={Form} method="patch" sx={{ width: '40%' }}>
            <Stack spacing={2}>
                <Stack>
                    <Autocomplete
                        disablePortal
                        id="cm-account"
                        options={cmAccountList}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => <li {...props} key={option.id}>
                            {option.name}
                        </li>}
                        value={cmAccount}
                        onChange={(e, value) => { setCmAccount(value) }}
                        renderInput={(params) => <TextField {...params} label="Cm Account" />}
                    />
                    <input type="number" hidden value={cmAccount?.id} name="cm_account_id" readOnly />
                </Stack>
                <Stack>
                    <input type="number" hidden value={currentUserDetails.id} name="user_id" readOnly />
                </Stack>
                <Stack>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                    >Save </Button>
                </Stack>

                {/* </Item> */}

            </Stack>
        </Box>
    );
};

export default SwitchCmAccountForm;